import { Component } from 'utils';
import { reportsActions } from "../../../../../store/reducers/reportsReducer";
import * as lodash from "lodash";

@Component({
    controllerAs: 'vm',
    template: require('./reportFilter.tpl.html'),
    bindings: {
        data: '<',
        onFilter: '&'
    }
})
export class ReportFilterSummrizeComponent {
    static $inject = ['$state', 'store'];

    get data() {
        return this._data;
    }

    set data(value) {
        this._data = value;
    }

    constructor($state, store) {
        this.store = store;
        this.waitingForResponseInstances = true;
        this.unSubscribe = store.subscribe(() => {
            if (this.store.getState().reports.instances && this.store.getState().reports.instances.hasOwnProperty) {
                this.instances = [];
                Object.keys(this.store.getState().reports.instances).forEach(key => {
                    this.instances.push({ 'id': key, 'name': this.store.getState().reports.instances[key] });
                });
                this.instances = [...this.instances];
                if (!this.selectedInstance) {
                    this.selectedInstance = this.instances[0];
                }
                if (!this.selectedSchema) {
                    this.setSchemas();
                    this.selectedSchema = {}
                }
            }

            if (this.waitingForResponseSchemas && this.store.getState().reports.schemas) {
                this.waitingForResponseSchemas = false;
                let schemas = [];
                Object.keys(this.store.getState().reports.schemas).forEach(key => {
                    schemas.push({ 'id':key, 'name':this.store.getState().reports.schemas[key] });
                });
                let ids = schemas.map(obj => obj.id);
                schemas = lodash.orderBy(schemas, ['name'],['asc']);
                schemas.splice(0, 0, { 'id': ids.toString(), 'name': 'All' });
                if (schemas.length > 0)
                    this.schemas = schemas;
                this.selectedSchema = this.schemas[0];
            }
        });

        this.$onDestroy = function () {
            this.schemas = null;
            this.unSubscribe();
        }
    }

    open(e) {
        e.stopPropagation();
        this.opened = true;
    }

    setSchemas() {
        this.schemas = [];
        this.selectedSchema = {};
        this.waitingForResponseSchemas = true;
        this.store.dispatch({ type: reportsActions.GET_SCHEMAS_FOR_REPORT, payload: { instanceId: this.selectedInstance.id } });
    }

    selectedTime(data) {
        this.fromDate = new Date(data.value.fromDate);
        this.toDate = new Date(data.value.toDate);
        this.isCustom = (data.name == 'Custom') ? true : false;
        if (this.isCustom) {
            this.initFrom = false;
            this.initTo = false;
        }
    }

    inValidFromDate(state) {
        if (state == true) {
            this.fromDateInValid = true;
            return 'inValidDate';
        }
        this.fromDateInValid = false;
        return '';
    }

    inValidToDate(state) {
        if (state == true) {
            this.toDateInValid = true;
            return 'inValidDate';
        }
        this.toDateInValid = false;
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/reports/report-summrize/reportFilter/reportFilter.js